import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import { CONTENT } from "@/content";

const T = CONTENT.auth;
const appearance = {
  elements: {
    rootBox: { width: "100%" },
    cardBox: { width: "100%", boxShadow: "none", border: "none", borderRadius: 0, background: "transparent" },
    card: { boxShadow: "none", background: "transparent", padding: "8px 0", border: "none" },
    header: { display: "none" },
    footer: { background: "transparent" },
    footerAction: { display: "none" },
    formFieldInput: "nb-clerk-input",
    formButtonPrimary: "nb-clerk-primary",
    socialButtonsBlockButton: "nb-clerk-social",
  },
};

export default function Account() {
  const [tab, setTab] = useState(window.location.search.includes("__clerk_ticket") ? "signIn" : "signUp");
  return (
    <main className="page auth-page" data-testid="account-page">
      <Show when="signed-in"><Navigate to="/my-shares" replace /></Show>
      <div className="nb-card account-card">
        <div className="tabs account-tabs" role="tablist">
          {["signUp", "signIn"].map((t) => (
            <button key={t} role="tab" aria-selected={tab === t} className={`tab ${tab === t ? "active" : ""}`} onClick={() => setTab(t)} data-testid={`account-tab-${t}`}>
              {T.tabs[t]}
            </button>
          ))}
        </div>
        {tab === "signUp" ? (
          <>
            <SignUp routing="hash" appearance={appearance} signInUrl="/account" />
            <p className="legal-line" data-testid="account-legal-line">{T.legalPrefix}<Link to={T.legalTo}>{T.legalLink}</Link>{T.legalSuffix}</p>
          </>
        ) : (
          <SignIn routing="hash" appearance={appearance} signUpUrl="/account" />
        )}
      </div>
    </main>
  );
}
